import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./pages/home"
import Map from "./pages/map"
import PersonalArea from './pages/lk_rk';

import DatasetsPage from "./pages/lk_rk/myDatasetsPage"
import DatasetTablePage from './pages/lk_rk/datasetTablePage';
import ImportDatasetsPage from './pages/lk_rk/importDatasetPage';
import TuneMetadataPage from './pages/lk_rk/tuneMetadataPage';
import DecomposerPage from './pages/lk_rk/decomposerPage';
import NormaliserPage from './pages/lk_rk/normaliserPage';
import GeometryTransformerPage from './pages/lk_rk/geometryTransformerPage';
import ConnectorPage from './pages/lk_rk/connectorPage';
import PublisherPage from './pages/lk_rk/publisherPage';
import TarifsPage from './pages/lk_rk/tarifsPage';
import Description from './pages/description';
import Geocoder from './pages/geocoder'
import { NotFound } from './components/notFound';
import { useState, useEffect } from 'react';
import WindowSizeContext from './utils/WindowSizeContext';

function App() {
  useEffect(() => {
    if (window.location.href.includes('#/')) window.location.href = window.location.href.replace('#/', '');
    fetch(window.location.href)
      .then(response => {
        if (!response.ok) {
          // make the promise be rejected if we didn't get a 2xx response
          throw new Error("Not 2xx response", { cause: response });
        } else {
          // got the desired response
        }
      })
      .catch(error => {
        if (window.location.pathname !== '/not-found') window.location.href = '/not-found';
      })
  }, [])

  const [user, setUser] = useState(false);

  const size = useWindowSize();

  function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: document.body.clientWidth,
      height: document.body.clientHeight
    });
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: document.body.clientWidth,
          height: document.body.clientHeight
        });
      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
  }

  return (
    <WindowSizeContext.Provider value={size}>
      <BrowserRouter>
        <Routes >
          <Route index element={<Home setUser={setUser} />} />
          <Route path="map" element={<Map />} />
          <Route path="lk">
            <Route index element={<DatasetsPage />} />
            <Route path="MyDatasets" element={<DatasetsPage />} />
            <Route path="DatasetTable" element={<DatasetTablePage />} />
            <Route path="ImportDataset" element={<ImportDatasetsPage />} />
            <Route path="TuneMetadata" element={<TuneMetadataPage />} />
            <Route path="Decomposer" element={<DecomposerPage />} />
            <Route path="Normaliser" element={<NormaliserPage />} />
            <Route path="GeometryTransformer" element={<GeometryTransformerPage />} />
            <Route path="Connector" element={<ConnectorPage />} />
            <Route path="Exporter" element={<PublisherPage />} />
            <Route path="Tarifs" element={<TarifsPage />} />
          </Route>
          <Route path="what" element={<Description type={1} user={user} setUser={setUser} />} />
          <Route path="why" element={<Description type={2} user={user} setUser={setUser} />} />
          <Route path="how" element={<Description type={3} user={user} setUser={setUser} />} />
          <Route path="geocoder" element={<Geocoder user={user} setUser={setUser} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </WindowSizeContext.Provider >
  );
}

export default App;